import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import { ChangedByInfoDto } from 'api';
import { Namespace, ParseKeys } from 'i18next';
import { TextDisplay } from 'library/components/controls/display/TextDisplay';
import { getLocalizedDateFormat } from 'library/formatters/DateFormatter';
import { formatValueWithSecondInBracket } from 'library/formatters/StringFormatter';
import { Sxable } from 'library/types';

export interface ChangedByInfoDisplayProps extends Sxable {
	label?: ParseKeys<Namespace>;
	changedByInfo?: ChangedByInfoDto | null;
}

export const ChangedByInfoDisplay = ({
	label = 'common:updated-by',
	changedByInfo,
	sx,
}: ChangedByInfoDisplayProps): React.JSX.Element => {
	const { t } = useTranslation(['common']);

	if (!changedByInfo?.changedByUserId) {
		return <Box />;
	}

	return (
		<TextDisplay
			label={t(label as ParseKeys<'common'>)}
			value={
				<>
					{changedByInfo.changedByUserId}
					<p>
						{formatValueWithSecondInBracket(
							changedByInfo.changedByCustomerOrgName,
							changedByInfo.changedByCustomerNumber
						)}
					</p>
				</>
			}
			helperText={getLocalizedDateFormat(changedByInfo.changedOnDate)}
			sx={sx}
		/>
	);
};
